import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
  },
  data: function() {
    return {
      // baseApiUrl: "https://newapi.timtime.ir",
      // baseApiUrl: process.env.BASE_API_URL, // "http://localhost:3000",
      // appTitle: process.env.APP_TITLE, // "FuDev-AdminPanel",
      // shortTitle: process.env.SHORT_TITLE, // "AdminPanel",
      // companyWebsite: process.env.COMPANY_WEBSITE, // "https://fudev.ir",
      // companyName: process.env.COMPANY_NAME, // "Fudev Group",
      // registrationIsActive: process.env.REGISTRATION_ACTIVE === "true", // false,
      // homePageText: process.env.HOME_PAGE_TEXT, // "Become a professional company in user-based world",

      baseApiUrl: "https://api.allamehkarbaschian.ir",
      //baseApiUrl: "http://localhost:3000",
      appTitle: "AdminPanel",
      shortTitle: "Admin Panel",
      companyWebsite: "https://allamehkarbaschian.ir",
      companyName: "Allameh Karbaschian",
      registrationIsActive: false,
      homePageText: "",
    };
  },
  methods: {
    getUrl(path) {
      return `${this.baseApiUrl}${path}`;
    },
    getHeaders() {
      return {
        app: this.$store.state.app,
        //Authorization: `Bearer ${this.$store.state.token}`,
      };
    },
    signOut() {
      this.$store.commit("signOut");
      this.$router.push("/");
    },
  },
};
